import { List } from '@mui/material';
import { useEffect } from 'react';
import { downloadHistoryStore } from '@/stores/downloadHistoryStore';
import Loading from '../Loading';
import { AnimatedDrawer } from './AnimatedDrawer';
import { DataGenerationHistoryItem } from './DataGenerationHistoryItem';
import { DrawerHeader } from './DrawerHeader';
import { EmptyState } from './EmptyState';
import { ErrorState } from './ErrorState';
import { useGetDownloadHistory } from './hooks/useGetDownloadHistory';
import { styles } from './styles';

const HistoryList = ({ isOpen }: { isOpen: boolean }) => {
  const { getDownloadHistory, downloadHistory, loading, error } = useGetDownloadHistory({
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (isOpen) {
      getDownloadHistory();
    }
  }, [isOpen, getDownloadHistory]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorState onRetry={getDownloadHistory} />;
  }

  if (downloadHistory.length === 0) {
    return <EmptyState />;
  }

  return (
    <List sx={styles.historyList}>
      {downloadHistory.map(download => (
        <DataGenerationHistoryItem key={download.id} download={download} />
      ))}
    </List>
  );
};

export const DataGenerationHistoryDrawer = () => {
  const isOpen = downloadHistoryStore.use.isOpen();
  const setOpen = downloadHistoryStore.use.setOpen();

  return (
    <AnimatedDrawer.Root isOpen={isOpen} onClose={() => setOpen(false)}>
      <AnimatedDrawer.Backdrop sx={styles.drawerBackdrop} />
      <AnimatedDrawer.Content sx={styles.drawerContent}>
        <DrawerHeader />
        <HistoryList isOpen={isOpen} />
      </AnimatedDrawer.Content>
    </AnimatedDrawer.Root>
  );
};
